<script>
  export let size = "16";
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5H2C1.60218 15.5 1.22064 15.342 0.93934 15.0607C0.658035 14.7794 0.5 14.3978 0.5 14V8C0.5 3.85775 3.85775 0.5 8 0.5ZM8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8V14H8C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2ZM8 9.5C8.19116 9.50021 8.37502 9.57341 8.51403 9.70464C8.65303 9.83586 8.73668 10.0152 8.74788 10.206C8.75908 10.3969 8.69699 10.5848 8.5743 10.7314C8.45161 10.878 8.27757 10.9722 8.08775 10.9948L8 11H5.75C5.55884 10.9998 5.37498 10.9266 5.23597 10.7954C5.09697 10.6641 5.01332 10.4848 5.00212 10.294C4.99092 10.1031 5.05301 9.91522 5.1757 9.76863C5.29839 9.62204 5.47243 9.52783 5.66225 9.50525L5.75 9.5H8ZM10.25 6.5C10.4489 6.5 10.6397 6.57902 10.7803 6.71967C10.921 6.86032 11 7.05109 11 7.25C11 7.44891 10.921 7.63968 10.7803 7.78033C10.6397 7.92098 10.4489 8 10.25 8H5.75C5.55109 8 5.36032 7.92098 5.21967 7.78033C5.07902 7.63968 5 7.44891 5 7.25C5 7.05109 5.07902 6.86032 5.21967 6.71967C5.36032 6.57902 5.55109 6.5 5.75 6.5H10.25Z"
    style="fill: black !important;"
  />
</svg>
